/* IfShe sticky add-to-cart bar (new code; 2026-10-14 redesign).
   Visible only after the real add button has scrolled above the viewport, and hidden again while the footer is on
   screen (so it never covers the footer). Uses scroll position (rAF-throttled) instead of IntersectionObserver: a jump
   from page bottom straight to top never crosses the viewport, so an observer would leave the bar stuck on screen.
   Personalised products (options panel open by default): until the required fields are filled the button reads
   "Personalise" and scrolls to the first empty field; once they are filled it reads "Add to cart" and clicks the real
   button, so validation, the up-charge line and the cart redirect all stay with the options engine. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-ifshe-sticky-atc]');
  var real = document.querySelector('.product-form__submit[name="add"]');
  if (!bar || !real) return;
  var btn = bar.querySelector('button');
  var label = btn.querySelector('span') || btn;
  var hasPo = bar.getAttribute('data-has-po') === '1';
  var footer = document.querySelector('.footer') || document.querySelector('footer');
  var ticking = false;

  function panel() { return document.querySelector('.ifshe-po[data-ifshe-options]'); }

  // Mirrors the options engine's required checks (text / select / radio, swatch & image cards, photo editor).
  // Disabled controls belong to hidden conditional fields and are skipped, as the engine does.
  function firstIncomplete(root) {
    var i, el, list = root.querySelectorAll('[required]');
    for (i = 0; i < list.length; i++) {
      el = list[i];
      if (el.disabled) continue;
      if (el.type === 'radio') {
        if (!root.querySelector('[name="' + el.name + '"]:checked')) return el;
      } else if (el.type === 'file') {
        if (!(el.files && el.files.length)) return el;
      } else if (!(el.value && String(el.value).trim())) return el;
    }
    list = root.querySelectorAll('[data-po-required="true"]');
    for (i = 0; i < list.length; i++) {
      el = list[i];
      if (!el.disabled && !(el.value && String(el.value).trim())) return el.closest('.ifshe-po__field') || el;
    }
    list = root.querySelectorAll('.ifshe-po__editor[data-required="true"]');
    for (i = 0; i < list.length; i++) {
      var fm = list[i].querySelector('.ifshe-po__editor-file');
      if (fm && !fm.disabled && !(fm.files && fm.files.length)) return list[i];
    }
    return null;
  }

  function refreshLabel() {
    if (!hasPo) return;
    var root = panel();
    var done = !root || !firstIncomplete(root);
    var text = done ? bar.getAttribute('data-label-add') : bar.getAttribute('data-label-po');
    if (text && label.textContent !== text) label.textContent = text;
  }

  function update() {
    ticking = false;
    var above = real.getBoundingClientRect().bottom < 0;
    var footerIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
    var show = above && !footerIn;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();

  if (hasPo) {
    var refresh = function () { requestAnimationFrame(refreshLabel); };
    document.addEventListener('input', refresh, true);
    document.addEventListener('change', refresh, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.ifshe-po')) setTimeout(refreshLabel, 0);
    }, true);
    refreshLabel();
  }

  // Keep the bar price in step with the main price (variant changes re-render it).
  var priceBox = document.getElementById('price-' + bar.getAttribute('data-section'));
  var barPrice = bar.querySelector('.ifshe-sticky-atc__price');
  if (priceBox && barPrice && window.MutationObserver) {
    new MutationObserver(function () {
      var p = priceBox.querySelector('.price-item--last') || priceBox.querySelector('.price-item--regular');
      if (p && p.textContent.trim()) barPrice.textContent = p.textContent.trim();
    }).observe(priceBox, { childList: true, subtree: true, characterData: true });
  }

  btn.addEventListener('click', function () {
    if (hasPo) {
      var root = panel();
      var miss = root && firstIncomplete(root);
      if (miss) {
        var field = (miss.closest && miss.closest('.ifshe-po__field')) || miss;
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    if (real.disabled) {
      real.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    real.click();
  });
})();
